import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { compact } from 'lodash-es';
import { Callout, Typography } from 'seagull';
import { getServiceChangeBullets } from '~/business-logic/amendmentsLogic';
import ServicePanel from '~/components/ServicePanel/ServicePanel';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { getAccountingDetails } from '~/integrations/Accounting/accounting.utils';
import { serviceModel } from '~/models';
import { Accounting } from '~/types/api.model';
import AmendmentChangesInAgreementView from './AmendmentChangesInAgreementView';
function getIntegratedClassName(qboClasses, integratedClassId) {
    if (!qboClasses || !integratedClassId) return null;
    const qboClass = qboClasses.find((param)=>{
        let { id } = param;
        return id === integratedClassId;
    });
    if (!qboClass) return null;
    return qboClass.name;
}
export default function AgreementServiceInstance(props) {
    const { service, idx, serviceDetailsProps, qboClasses } = props;
    const { SERVICE_TEMPLATE_BUNDLE = false } = useFeatureFlags();
    const approvalMethod = serviceModel.approvalMethod(service);
    const autoApprovalDate = approvalMethod ? approvalMethod.autoApprovalDate() : null;
    const integratedClassId = serviceModel.integratedClassId(service);
    const integratedClassName = getIntegratedClassName(qboClasses, integratedClassId);
    const changeBullets = useMemo(()=>serviceModel.isCompleted(service.status) ? [] : getServiceChangeBullets(service, SERVICE_TEMPLATE_BUNDLE), [
        service,
        SERVICE_TEMPLATE_BUNDLE
    ]);
    return /*#__PURE__*/ _jsx(ServicePanel, _object_spread_props(_object_spread({
        serviceOrigin: "agreement",
        context: "agreement",
        isReadOnly: true,
        showBulletPoints: true,
        error: false,
        service: service,
        idx: idx
    }, serviceDetailsProps), {
        additionalSections: compact([
            integratedClassName && {
                disableBorder: true,
                value: /*#__PURE__*/ _jsxs(Callout, {
                    testId: "service-".concat(idx, "-qbo-class-callout"),
                    children: [
                        "When syncing invoices to ",
                        getAccountingDetails(Accounting.QBO).fullName,
                        ", the assigned class is set to",
                        ' ',
                        /*#__PURE__*/ _jsx(Typography, {
                            as: "span",
                            weight: "bold",
                            children: integratedClassName
                        }),
                        ". This indication is not visible to your client."
                    ]
                })
            }
        ]),
        footer: changeBullets.length > 0 && /*#__PURE__*/ _jsx(AmendmentChangesInAgreementView, {
            items: changeBullets,
            autoApprovalDate: autoApprovalDate,
            existingNote: serviceModel.note(service),
            testId: "service-".concat(idx, "-changes")
        })
    }));
}
